import { forwardRef } from "react";
import { cn } from "@/lib/cn";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  startIcon?: React.ReactNode;
  startAddon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  // fallow-ignore-next-line complexity
  ({ className, error, startIcon, startAddon, ...props }, ref) => {
    const inputClasses = cn(
      "box-border h-11 w-full appearance-none rounded-sm border-[1.5px] border-fog bg-surface px-3.5 py-2 text-[16px] leading-6 text-ink placeholder:text-slate transition-[border-color,box-shadow] duration-short ease-default",
      "focus:outline-none focus:border-electric focus:ring-2 focus:ring-electric-50",
      "disabled:opacity-40 disabled:cursor-not-allowed",
      error && "border-danger focus:border-danger focus:ring-danger/20",
      startIcon && "pl-10",
      startAddon && "pl-8",
      className,
    );

    if (startIcon || startAddon) {
      return (
        <div className="relative">
          {startIcon && (
            <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate pointer-events-none">
              {startIcon}
            </span>
          )}
          {startAddon && (
            <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate font-medium pointer-events-none">
              {startAddon}
            </span>
          )}
          <input ref={ref} className={inputClasses} {...props} />
        </div>
      );
    }

    return <input ref={ref} className={inputClasses} {...props} />;
  },
);

Input.displayName = "Input";

export { Input, type InputProps };
